<template>
  <div>
    <v-container class="Kanit pt-3">
      <div class="text-center">
        <div class="mb-3">
          รีวิวช่าง
          <span style="color: #0c4d9d; font-weight: 500">{{
            query.paintername
          }}</span>
        </div>

        <div style="width: 30%; margin-left: auto; margin-right: auto">
          <v-img
            style="border-radius: 10px"
            height="100px"
            :src="query.painterprofile"
          ></v-img>
        </div>
      </div>
      <div class="mt-4 px-4">
        <v-row no-gutters class="mb-3">
          <v-col cols="6">
            <div class="headtext">ความรวดเร็วในการให้บริการ</div>
            <div class="subtext">การให้บริการรวดเร็ว ไม่ต้องรอนาน</div>
          </v-col>
          <v-col cols="6">
            <star-rating
              v-model="input.speed_of_service"
              :inline="true"
              :show-rating="false"
              :border-width="2"
              border-color="#d8d8d8"
              :rounded-corners="true"
              :star-size="18"
              inactive-color="white"
            ></star-rating>
          </v-col>
        </v-row>
        <v-row no-gutters class="mb-3">
          <v-col cols="6">
            <div class="headtext">การให้บริการ</div>
            <div class="subtext">การให้ความช่วยเหลือและให้คำแนะนำ</div>
          </v-col>
          <v-col cols="6">
            <star-rating
              :inline="true"
              :show-rating="false"
              :border-width="2"
              v-model="input.customer_service"
              border-color="#d8d8d8"
              :rounded-corners="true"
              :star-size="18"
              inactive-color="white"
            ></star-rating>
          </v-col>
        </v-row>
        <v-row no-gutters class="mb-3">
          <v-col cols="6">
            <div class="headtext">ฝีมือและความเชี่ยวชาญ</div>
            <div class="subtext">มีความรู้ เชี่ยวชาญในการทำงาน</div>
          </v-col>
          <v-col cols="6">
            <star-rating
              :inline="true"
              :show-rating="false"
              v-model="input.skill"
              :border-width="2"
              border-color="#d8d8d8"
              :rounded-corners="true"
              :star-size="18"
              inactive-color="white"
            ></star-rating>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="6">
            <div class="headtext">ความคุ้มค่าของราคา</div>
            <div class="subtext">เมื่อเทียบกับราคาและผลงานที่ได้รับ</div>
          </v-col>
          <v-col cols="6">
            <star-rating
              :inline="true"
              :show-rating="false"
              :border-width="2"
              v-model="input.worthiness"
              border-color="#d8d8d8"
              :rounded-corners="true"
              :star-size="18"
              inactive-color="white"
            ></star-rating>
          </v-col>
        </v-row>
      </div>
      <div class="px-4 mt-6">
        <v-textarea
          v-model="input.remark"
          placeholder="ช่างทำงานเป็นอย่างไรบ้าง"
          rows="5"
          style="font-size: 13px; border-radius: 12px"
          outlined
        ></v-textarea>
      </div>
      <div class="text-center">
        <v-btn
          @click="confirmData"
          :loading="saveloading"
          class="px-9"
          depressed
          dark
          dense
          small
          color="#0c4d9d"
          rounded
          >ยืนยันการรีวิว</v-btn
        >
      </div>
    </v-container>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
import axios from "axios";

export default {
  components: {
    StarRating,
  },
  data() {
    return {
      saveloading: false,
      input: {
        speed_of_service: 1, // ความเร็วในการให้บริการ
        customer_service: 1, // การให้บริการ
        skill: 1, // ฝีมือและความเชี่ยวชาญ
        worthiness: 1, // ความคุ้มค่า
        remark: "", // เพิ่มเติม ไม่ require
      },
    };
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
  },
  mounted() {},
  methods: {
    async confirmData() {
      if (!this.saveloading) {
        var data = {
          userid: this.$store.state.userid,
          apptype: this.query.apptype,
          pageid: this.query.pageid,
          painterid: this.query.painterid,
          orderid: this.query.orderid,
          speed_of_service: this.input.speed_of_service,
          customer_service: this.input.customer_service,
          skill: this.input.skill,
          worthiness: this.input.worthiness,
          remark: this.input.remark,
        };
        this.saveloading = true;
        axios
          .post(
            "https://communitybotbyzwizai.herokuapp.com/toacustomerreviewpainter",
            data,
            {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            }
          )
          .then(async (response) => {
            this.saveloading = false;
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              return;
            } else if (response.data.responsecode == 200) {
              await this.$swal.fire({
                icon: "success",
                text: "สำเร็จ",
              });
              if (this.query.apptype == "line") {
                await this.$liff.closeWindow();
              } else if (this.query.apptype == "facebook") {
                this.$store.dispatch("messengerClose");
              }
            } else {
              await this.$swal.fire({
                icon: "error",
                text: `Error code: ${response.data.responsecode}, ${response.data.reason}`,
              });
            }
          });
      }
    },
  },
};
</script>

<style lang="scss">
.headtext {
  font-weight: 600;
  font-size: 10px;
}
.subtext {
  font-size: 9px;
  line-height: 10px;
}
.v-textarea textarea {
  line-height: 18px;
}
</style>